/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { expandConstants } from 'utils';

import { getCurrentAdvertiserId } from 'modules/organization/organizationSlice';
import {
  setAdvancedConfiguration,
  setDefaultAdvancedConfiguration,
} from 'modules/performance/performanceSlice';

import { useOrganization } from '../organization/useOrganization';
import { selectConstants, useApiDataSlicePrefetch } from './dataApiSlice';

export const useDataPrefetch = () => {
  const dispatch = useDispatch();
  const { dsp } = useOrganization();
  const prefetchConstants = useApiDataSlicePrefetch('constants');
  const prefetchMediaTypes = useApiDataSlicePrefetch('mediaTypes');
  const prefetchDeviceTypes = useApiDataSlicePrefetch('deviceTypes');
  const prefetchAudiences = useApiDataSlicePrefetch('audiences');
  const prefetchPublishers = useApiDataSlicePrefetch('publishers');
  const prefetchCreatives = useApiDataSlicePrefetch('creatives');
  const prefetchLineItems = useApiDataSlicePrefetch('lineItems');
  const prefetchSubcategories = useApiDataSlicePrefetch('subcategories');
  const prefetchInsertionOrders = useApiDataSlicePrefetch('insertionOrders');
  const prefetchCountries = useApiDataSlicePrefetch('countries');

  const advertiserId = useSelector(getCurrentAdvertiserId);
  const constants = useSelector(selectConstants);

  useEffect(() => {
    prefetchConstants(null);
    prefetchDeviceTypes({ dsp });

    if (advertiserId && dsp) {
      prefetchMediaTypes({ dsp });
      prefetchPublishers({ dsp });
      prefetchCreatives({ advertiserId, dsp });
      prefetchAudiences({ advertiserId, dsp });
      prefetchInsertionOrders({ advertiserId, dsp });
      prefetchLineItems({ advertiserId, dsp });
      prefetchSubcategories(advertiserId);
      prefetchCountries({ dsp });
    }
  }, [
    prefetchConstants,
    prefetchDeviceTypes,
    prefetchMediaTypes,
    prefetchAudiences,
    prefetchCreatives,
    prefetchInsertionOrders,
    prefetchPublishers,
    prefetchLineItems,
    prefetchSubcategories,
    prefetchCountries,
    advertiserId,
  ]);

  useEffect(() => {
    if (constants) {
      const configuration = {
        methodology: expandConstants(constants.MethodologyOptions).LAST_TOUCH.value,
        showUniques: constants.AttributionSettings.TOTAL.value,
        conversionWindow: constants.ConversionWindow[constants.ConversionWindow.length - 1],
      };

      dispatch(setDefaultAdvancedConfiguration(configuration));
      dispatch(setAdvancedConfiguration(configuration));
    }
  }, [constants]);
};
